/** Token persistido no markdown: [[arquivo:ID|caminho/no/repo]] */
export const REGEX_MENCAO_ARQUIVO = /\[\[arquivo:(\d+)(?:\|([^\]]*))?\]\]/g;

export function tokenMencaoArquivo(arquivoId, caminho) {
  const id = parseInt(arquivoId, 10);
  if (Number.isNaN(id)) return '';
  const label = String(caminho || '').replace(/\]\]/g, '').trim();
  return `[[arquivo:${id}|${label}]]`;
}

export function extrairIdsMencao(conteudo) {
  const ids = new Set();
  if (conteudo == null || conteudo === '') return [];
  const re = new RegExp(REGEX_MENCAO_ARQUIVO.source, 'g');
  let m;
  while ((m = re.exec(String(conteudo))) !== null) {
    const id = parseInt(m[1], 10);
    if (!Number.isNaN(id)) ids.add(id);
  }
  return Array.from(ids);
}

/** Detecta @ no cursor para autocomplete (similar ao editor de chamado). */
export function detectarMencaoArquivo(texto, caret) {
  const antes = String(texto || '').slice(0, caret);
  const m = antes.match(/(?:^|[\s(])@([^\s@]{0,80})$/);
  if (!m) return null;
  return {
    query: m[1] || '',
    inicio: caret - (m[1] || '').length - 1,
  };
}
